export default {
  bind(el, binding) {
    el.__vueOutsideClick__ = function (event) {
      // 자신 또는 자식 클릭이면 무시
      if (el === event.target || el.contains(event.target)) {
        return;
      }

      // 바인딩된 함수 실행
      if (typeof binding.value === 'function') {
        binding.value(event);
      }
    };

    document.addEventListener('click', el.__vueOutsideClick__);
  },

  unbind(el) {
    document.removeEventListener('click', el.__vueOutsideClick__);
    delete el.__vueOutsideClick__;
  },
};
